import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  return <section id="pricing" className="py-6 sm:py-12 px-4 bg-brand-cream scroll-mt-10" data-id="element-98">
      <div className="max-w-xl mx-auto" data-id="element-99">
        <div className="text-center mb-6 sm:mb-8" data-id="element-100">
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-text-main" data-id="element-101">
            SCEGLI LA TUA TRASFORMAZIONE
          </h2>
        </div>

        <div className="flex flex-col space-y-6 sm:space-y-8" data-id="element-102">
          {/* OPZIONE 1: PACK ESSENTIAL */}
          <div className="bg-white border border-brand-olive rounded-2xl p-5 sm:p-6" data-id="element-103">
            <h3 className="text-base sm:text-lg font-bold text-brand-text-main mb-2 uppercase" data-id="element-104">
              OPZIONE 1: PACK ESSENTIAL
            </h3>
            <p className="text-xs sm:text-sm text-brand-text-muted mb-5" data-id="element-105">
              Tutto il sistema per cambiare la tua cucina.
            </p>

            <div className="space-y-2.5 sm:space-y-3 mb-6" data-id="element-106">
              {["L'Enciclopedia Reset (Oltre 500 Ricette)", 'Tutte le 6 Guide Operative "Apri e Applica"', 'Tutti i 4 Bonus Esclusivi (Snack, Spesa, Airfryer, Ristorante)', 'Accesso immediato e permanente (PDF HD)'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-107">
                  <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-olive shrink-0 mt-0.5" data-id="element-108" />
                  <span className="text-xs sm:text-sm text-brand-text-main font-medium" data-id="element-109">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="flex justify-between items-center border-t border-gray-100 pt-4 mb-5" data-id="element-110">
              <div data-id="element-111">
                <span className="text-[10px] sm:text-xs text-brand-text-muted uppercase font-bold block" data-id="element-112">
                  Valore Reale
                </span>
                <span className="text-base sm:text-lg text-gray-400 line-through" data-id="element-113">
                  €195
                </span>
              </div>
              <div className="text-right" data-id="element-114">
                <span className="text-[10px] sm:text-xs text-brand-olive uppercase font-bold block" data-id="element-115">
                  Oggi Solo
                </span>
                <span className="text-2xl sm:text-3xl font-bold text-brand-text-main" data-id="element-116">
                  €19,90
                </span>
              </div>
            </div>

            <CTAButton href="https://italia.kitonline.shop/cart/44759694901383:1" variant="primary" className="w-full" data-id="element-117">
              🚀 VOGLIO IL PACK ESSENTIAL
            </CTAButton>
          </div>

          {/* OPZIONE 2: BUNDLE RESET PREMIUM */}
          <div className="bg-brand-olive-dark text-white rounded-2xl p-5 sm:p-6 relative border border-brand-gold/30" data-id="element-118">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-gold text-white font-bold px-3 py-1 rounded-full text-[10px] sm:text-xs uppercase tracking-wide flex items-center gap-1 whitespace-nowrap" data-id="element-119">
              <StarIcon className="w-3 h-3 fill-current" data-id="element-120" />
              La scelta più popolare
            </div>

            <h3 className="text-base sm:text-lg font-bold text-brand-gold mb-2 mt-1 uppercase" data-id="element-121">
              OPZIONE 2: BUNDLE RESET PREMIUM ⭐
            </h3>
            <p className="text-xs sm:text-sm text-gray-200 mb-5" data-id="element-122">
              La scelta più popolare per chi non vuole sbagliare e desidera
              risultati 3x più veloci.
            </p>

            <div className="space-y-3 sm:space-y-4 mb-6" data-id="element-123">
              <div className="flex items-start gap-2" data-id="element-124">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-125" />
                <span className="text-xs sm:text-sm font-medium" data-id="element-126">
                  TUTTO il Pack Essential (Enciclopedia + 4 Bonus)
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-127">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-128" />
                <span className="text-xs sm:text-sm font-bold text-brand-gold" data-id="element-129">
                  ESCLUSIVO: IL PROTOCOLLO RESET 21 GIORNI
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-130">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-131" />
                <span className="text-xs sm:text-sm font-medium" data-id="element-132">
                  CALENDARIO GIORNALIERO PASSO-PASSO: Ti diciamo noi cosa
                  mangiare dalla mattina alla sera per 3 settimane. Zero dubbi,
                  zero errori.
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-133">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-134" />
                <span className="text-xs sm:text-sm font-medium" data-id="element-135">
                  VIDEO-GUIDA ESECUTIVA: I 3 pilastri per sgonfiare l'addome
                  nelle prime 48 ore.
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-136">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-137" />
                <span className="text-xs sm:text-sm font-medium" data-id="element-138">
                  SUPPORTO PRIORITARIO VIA EMAIL.
                </span>
              </div>
            </div>

            <div className="flex justify-between items-center border-t border-white/20 pt-4 mb-5" data-id="element-139">
              <div data-id="element-140">
                <span className="text-[10px] sm:text-xs text-gray-300 uppercase font-bold block" data-id="element-141">
                  Valore Reale
                </span>
                <span className="text-base sm:text-lg text-gray-400 line-through" data-id="element-142">
                  €292
                </span>
              </div>
              <div className="text-right" data-id="element-143">
                <span className="text-[10px] sm:text-xs text-brand-gold uppercase font-bold block" data-id="element-144">
                  Oggi Solo
                </span>
                <span className="text-3xl sm:text-4xl font-bold text-white" data-id="element-145">
                  €27,90
                </span>
              </div>
            </div>

            <CTAButton href="https://italia.kitonline.shop/cart/44759699554439:1" variant="premium" className="w-full" data-id="element-146">
              🚀 VOGLIO IL SISTEMA PREMIUM
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}